import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M27 6h-5.38l-1.45-2.9A1.99 1.99 0 0018.38 2h-4.76a1.99 1.99 0 00-1.8 1.1L10.39 6H5a1 1 0 000 2h1v20a2 2 0 002 2h16a2 2 0 002-2V8h1a1 1 0 000-2zM13.62 4h4.76l1 2h-6.76zM24 28H8V8h16z"/><path d="M13 26a1 1 0 001-1V11a1 1 0 00-2 0v14a1 1 0 001 1zM19 26a1 1 0 001-1V11a1 1 0 00-2 0v14a1 1 0 001 1z"/>';
export var TrashcanOutlineSVG = function TrashcanOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TrashcanOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TrashcanOutlineSVG);